const GTM_ID = "GTM-WZP9BZHB";
const GTAG_ID = "AW-18165581626";
const CLARITY_ID = "wk74jbx3pj";

let analyticsLoaded = false;

function runAfterPageLoad(callback: () => void) {
  if (document.readyState === "complete") {
    setTimeout(callback, 0);
    return;
  }
  window.addEventListener("load", () => setTimeout(callback, 0), { once: true });
}

function loadGtm() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  if (!document.getElementById("gtm-noscript")) {
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.prepend(noscript);
  }
}

function loadGtag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(script);

  window.gtag!("js", new Date());
  window.gtag!("config", GTAG_ID);
}

function loadClarity() {
  type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] };
  const clarity: ClarityFn = function clarityFn(...args: unknown[]) {
    (clarity.q = clarity.q || []).push(args);
  } as ClarityFn;
  window.clarity = clarity;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}

export function loadAnalytics() {
  if (typeof window === "undefined" || analyticsLoaded) return;
  analyticsLoaded = true;

  runAfterPageLoad(() => {
    loadGtm();
    loadGtag();
    setTimeout(loadClarity, 2000);
  });
}

export function grantAdStorageConsent() {
  if (typeof window === "undefined") return;
  const q = (window.uetq = window.uetq || []);
  q.push("consent", "update", { ad_storage: "granted" });
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
    uetq?: unknown[];
  }
}
